<template>
  <!--
      作者：zhuchangtao
      时间：2020-12-12
      描述：插件中心-抽奖活动
    -->
  <div class="common-seach-wrap">
    <!-- <el-tabs v-model="activeName">
      <el-tab-pane label="抽奖管理" name="sweepstakes"></el-tab-pane>

      <el-tab-pane label="奖项管理" name="sweepstakesawards"></el-tab-pane>
    </el-tabs> -->
    <!--抽奖管理-->
    <Sweepstakes v-if="activeName == 'sweepstakes'"></Sweepstakes>

    <!--奖项管理-->
    <SweepstakesAwards v-if="activeName == 'sweepstakesawards'"></SweepstakesAwards>

    <!--抽奖记录-->
    <Record v-if="activeName == 'record'"></Record>

    <!--抽奖管理-->
    <Setting v-if="activeName == 'setting'"></Setting>

  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Sweepstakes from './sweepstakes/index.vue';
import SweepstakesAwards from './sweepstakesawards/index.vue';
import Record from './record/index.vue';
import Setting from './setting/index.vue';

export default {
  components: {
    Sweepstakes,
    SweepstakesAwards,
    Record,
    Setting,
  },
  data() {
    return {

      /*当前选中*/
      activeName: 'sweepstakes',
      /*切换数组*/
      sourceList: [
        {
          key: 'sweepstakes',
          value: '抽奖管理',
          path:'/plus/sweepstakes/sweepstakes/index'
        },
        {
          key: 'sweepstakesawards',
          value: '奖项管理',
          path:'/plus/sweepstakes/sweepstakesawards/index'
        },
        {
          key: 'record',
          value: '抽奖记录',
          path:'/plus/sweepstakes/record/index'
        },
        {
          key: 'setting',
          value: '抽奖设置',
          path:'/plus/sweepstakes/setting/index'
        }
        
      ],
      /*权限筛选后的数据*/
      tabList:[],
    };
  },
  watch:{

    //监听路由
    $route(to, from) {
      this.init();
    }
  },
  created() {
    /*获取列表*/
    this.init();
  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type:'sweepstakes',list: [] });
    bus.$off('activeValue');
  },
  methods: {
    /*初始化方法*/
    init(){
      this.tabList=this.authFilter();

      if(this.tabList.length>0){
        this.activeName=this.tabList[0].key;
      }

      if (this.$route.query.type != null) {
        this.activeName = this.$route.query.type;
      }

      /*监听传插件的值*/
      bus.$on('activeValue', res => {
        // if (this.is_third_param) {
        //   this.param.user_id = '';
        //   this.is_third_param = false;
        // }
        this.activeName = res;
      });

      //发送类别切换
      let params = {
        active: this.activeName,
        list: this.tabList,
        tab_type:'sweepstakes'
      };
      bus.$emit('tabData', params);
    },

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/sweepstakes/index.vue